import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row q-col-gutter-md"
}
const _hoisted_2 = {
  key: 2,
  class: "text-center text-grey-6 q-pa-xl"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "No people detected yet", -1)
const _hoisted_4 = {
  key: 3,
  class: "q-mt-md text-center"
}
const _hoisted_5 = {
  key: 4,
  class: "q-mt-md text-center text-grey-6 text-caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_PersonCard = _resolveComponent("PersonCard")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_PersonDetailDialog = _resolveComponent("PersonDetailDialog")!
  const _component_EditPersonModal = _resolveComponent("EditPersonModal")!
  const _component_TrashPersonModal = _resolveComponent("TrashPersonModal")!
  const _component_MergePersonsModal = _resolveComponent("MergePersonsModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_linear_progress, {
          key: 0,
          color: "primary",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.persons.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
            return (_openBlock(), _createElementBlock("div", {
              key: person.id,
              class: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
            }, [
              _createVNode(_component_PersonCard, {
                person: person,
                selectable: _ctx.mergeMode,
                selected: _ctx.mergeSelectedIds.includes(person.id),
                onClick: _ctx.viewPerson,
                onEdit: _ctx.openEditModal,
                onTrash: _ctx.openTrashModal,
                onToggle: _ctx.toggleMergeSelect
              }, null, 8, ["person", "selectable", "selected", "onClick", "onEdit", "onTrash", "onToggle"])
            ]))
          }), 128))
        ]))
      : (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_q_icon, {
              name: "fa fa-users",
              size: "64px",
              class: "q-mb-md"
            }),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_InfiniteScroll, {
      active: _ctx.hasMore,
      loading: _ctx.loadingMore,
      class: "q-mt-md",
      onLoadMore: _ctx.loadMore
    }, null, 8, ["active", "loading", "onLoadMore"]),
    (_ctx.canMerge && _ctx.mergeSelectedIds.length >= 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            color: "primary",
            icon: "fa fa-compress-arrows-alt",
            label: `Merge ${_ctx.mergeSelectedIds.length} Persons`,
            onClick: _ctx.openMergeModal
          }, null, 8, ["label", "onClick"])
        ]))
      : (_ctx.canMerge)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Select at least 2 persons to merge "))
        : _createCommentVNode("", true),
    _createVNode(_component_PersonDetailDialog, {
      ref: "personDetailDialog",
      "client-id": _ctx.clientId,
      onUpdated: _ctx.onPersonUpdated
    }, null, 8, ["client-id", "onUpdated"]),
    _createVNode(_component_EditPersonModal, {
      ref: "editPersonModal",
      onUpdated: _ctx.onPersonUpdated
    }, null, 8, ["onUpdated"]),
    _createVNode(_component_TrashPersonModal, {
      ref: "trashPersonModal",
      onTrashed: _ctx.onPersonTrashed
    }, null, 8, ["onTrashed"]),
    _createVNode(_component_MergePersonsModal, {
      ref: "mergePersonsModal",
      onMerged: _ctx.onPersonsMerged
    }, null, 8, ["onMerged"])
  ]))
}